import combineResults from "../../../../utils/combineResultsData";

export const DEFAULT_SCRATCH_DEDUCTION = 0.1;

// Timed attempts that can be scratched, keyed by the block's first fieldId
export const scratchBlocks = combineResults.filter(
  (itemResult) => itemResult.unit === "seconds",
);

export const getScratchBlockId = (itemResult) => itemResult.test[0].fieldId;

export const scratchBlockIdByFieldId = Object.fromEntries(
  scratchBlocks.flatMap((itemResult) =>
    itemResult.test.map((itemTest) => [
      itemTest.fieldId,
      getScratchBlockId(itemResult),
    ]),
  ),
);

export const setScratch = (blockId, deduction) => {
  const checkbox = document.getElementById(`scratch-${blockId}`);
  const deductionInput = document.getElementById(`scratchDeduction-${blockId}`);
  if (!checkbox || !deductionInput) return;

  const isScratched = deduction !== null && deduction !== undefined;
  checkbox.checked = isScratched;
  deductionInput.disabled = !isScratched;
  deductionInput.value = isScratched ? deduction : "";
};

export const resetScratches = () =>
  scratchBlocks.forEach((itemResult) =>
    setScratch(getScratchBlockId(itemResult), null),
  );

// Returns the deduction in seconds, or null when the block isn't scratched
export const getScratchDeduction = (blockId) => {
  const checkbox = document.getElementById(`scratch-${blockId}`);
  const deductionInput = document.getElementById(`scratchDeduction-${blockId}`);
  if (!checkbox?.checked || !deductionInput) return null;
  return Number(deductionInput.value);
};

// Returns a message for the first scratched block without a valid deduction
export const getScratchError = () => {
  const invalidBlock = scratchBlocks.find((itemResult) => {
    const deduction = getScratchDeduction(getScratchBlockId(itemResult));
    return deduction !== null && !(deduction > 0);
  });
  if (!invalidBlock) return null;
  return `${invalidBlock.name} attempt ${invalidBlock.attempt}: the scratch deduction is required and must be greater than 0.`;
};
